import { Paper, Title } from '@mantine/core';
import { useState } from 'react';

import TransactionFilter from './transaction-filter';
import Table from './transactions-table.component';

import {
  AdminTransactionSelectData,
  TransactionFilterForm,
} from '../../type/filter.types';

import { useForm } from '@mantine/form';
import {
  BasicTransactionResponseDetails,
  BasicTransactionResponseSummary,
  RetrieveAllTransactionsRequest,
  TransactionStats,
} from '../../type/retrieve-transaction.types';
import './admin-transactions.styles.css';

import { IPaginationMeta } from '../../type/admin.types';
import AdminTransactionsDetails from './admin-transaction-details.component';

interface Props {
  isAdmin?: boolean;

  //isChecked?: number[];
  //setIsChecked?: React.Dispatch<React.SetStateAction<number[]>>;

  // checkedAll: boolean;
  // setCheckedAll: React.Dispatch<React.SetStateAction<boolean>>;
}
const ITEMS_PER_PAGE = 20;

const Transactions = (props: Props) => {
  const { isAdmin } = props;
  const [paginationData, setPaginationData] = useState<IPaginationMeta>();
  const [isLoadPartners, setIsLoadPartners] = useState<boolean>(true);
  const [data, setData] = useState<BasicTransactionResponseSummary[]>([]);
  const [page, setPage] = useState<number>(1);
  const [transactionStats, setTransactionStats] = useState<TransactionStats>();
  const [transactionDetails, setTransactionDetails] =
    useState<BasicTransactionResponseDetails[]>();
  const [detailsPaginationData, setDetailsPaginationData] =
    useState<IPaginationMeta>();
  const [transactionSummaryRequest, setTransactionSummaryRequest] =
    useState<RetrieveAllTransactionsRequest>();
  const [transactionDetailsRequest, setTransactionDetailsRequest] =
    useState<RetrieveAllTransactionsRequest>();
  const [showTransactionSummary, setShowTransactionSummary] = useState(true);

  const [isChecked, setIsChecked] = useState<number[]>([]);
  const [checkedAll, setCheckedAll] = useState<boolean>(false);

  const filterSelectData = useForm<AdminTransactionSelectData>({
    initialValues: {
      partnersData: [],
      resellersData: [],
      merchantsData: [],
      merchantBranchesData: [],
      posData: [],
      transactionStatusData: [],
    },
  });

  const transactionFilterForm = useForm<TransactionFilterForm>({
    initialValues: {
      dateRange: [null, null],
      industryMid: '',
      transactionStatus: '',
      partner: '',
      reseller: '',
      merchant: '',
      merchantBranch: '',
      pos: '',
    },
  });

  return (
    <>
      {showTransactionSummary ? (
        <>
          <Title order={2} my='lg'>
            Transactions
          </Title>
          <div className='admin-transactions'>
            <Paper
              withBorder
              radius='md'
              shadow='lg'
              style={{
                flex: 1,
                height: '100%',
                padding: '20px 0',
                overflow: 'auto',
              }}
            >
              <TransactionFilter
                setTransactionStats={setTransactionStats}
                form={transactionFilterForm}
                isAdmin={isAdmin}
                setData={setData}
                setPaginationData={setPaginationData}
                page={page}
                setPage={setPage}
                filterSelectData={filterSelectData}
                setIsLoadPartners={setIsLoadPartners}
                isLoadPartners={isLoadPartners}
                setTransactionSummaryRequest={setTransactionSummaryRequest}
                transactionSummaryRequest={transactionSummaryRequest}
                data={data}
                isChecked={isChecked}
                setTransactionDetails={setTransactionDetails}
                setDetailsPaginationData={setDetailsPaginationData}
                setTransactionDetailsRequest={setTransactionDetailsRequest}
                setShowTransactionSummary={setShowTransactionSummary}
              />
              <Table
                data={data}
                transactionStats={transactionStats}
                paginationData={paginationData}
                setPage={setPage}
                page={page}
                setTransactionDetails={setTransactionDetails}
                setShowTransactionSummary={setShowTransactionSummary}
                setDetailsPaginationData={setDetailsPaginationData}
                setTransactionDetailsRequest={setTransactionDetailsRequest}
                setIsLoadPartners={setIsLoadPartners}
                transactionSummaryRequest={transactionSummaryRequest}
                isChecked={isChecked}
                setIsChecked={setIsChecked}
                checkedAll={checkedAll}
                setCheckedAll={setCheckedAll}
              />
            </Paper>
          </div>
        </>
      ) : (
        <AdminTransactionsDetails
          transactionDetails={transactionDetails}
          detailsPaginationData={detailsPaginationData}
          transactionDetailsRequest={transactionDetailsRequest}
          setShowTransactionSummary={setShowTransactionSummary}
        />
      )}
    </>
  );
};

export default Transactions;
